import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestReplacePackSlots } from "./replacePackSlots.request";

const useReplacePackSlots = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestReplacePackSlots,
    ...options
  });
};

export default useReplacePackSlots;
